<script lang="ts" setup>
import { getMetaTags } from '~/utils/meta'
import type { BreadcrumbItem } from '@nuxt/ui'
import type { SEOPageKey } from '~/types/layouts'

interface SEOPageLayoutProps {
  seoKey: SEOPageKey
}

const props = defineProps<SEOPageLayoutProps>()

const { baseKey } = useI18n(`pages.seo.${props.seoKey}`)

const route = useRoute()
const heroImage = getRandomHeroImage(route.path)

useSeoMeta(
  getMetaTags(
    {
      title: '.meta.title',
      description: '.meta.description'
    },
    heroImage.value.src,
    baseKey
  )
)

useSchemaOrg(
  getSchemaOrg(
    {
      title: '.title',
      breadcrumbs: [{ name: '.title' }]
    },
    baseKey
  )
)

const breadcrumbItems: BreadcrumbItem[] = [
  {
    to: props.seoKey,
    label: '.title'
  }
]
</script>

<template>
  <NuxtLayout
    name="default"
    title=".title"
    :image="heroImage"
    :ui="{
      image: 'lg:object-[center_-3rem]'
    }"
  >
    <template #description>
      <slot name="description" />
    </template>

    <template #buttons>
      <slot name="buttons" />
    </template>

    <VBreadcrumb :items="breadcrumbItems" />

    <slot />

    <SocialMediaSection />
  </NuxtLayout>
</template>

<style scoped></style>
